import axios from "axios";

export default {
  namespaced: true,
  state: {
    accounts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    accountsMessage: ''
  },
  mutations: {
    CLEAR_ACCOUNTS(state) {
      state.accounts = [];
    },
    RECEIVED_ACCOUNTS(state, payload) {
      state.accounts = payload;
      state.isReceiving = false;
    },
    RECEIVING_ACCOUNTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_ACCOUNT(state, payload) {
      state = Object.assign(state, {
        accounts: [...state.accounts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ACCOUNT(state) {
      state.isReceiving = true;
    },
    UPDATED_ACCOUNT(state, payload) {
      let index = state.accounts.findIndex(account => account._id === payload._id);
      state = Object.assign(state, {
        accounts: state.accounts.map((account, i) => {
          if (i === index) {
            return Object.assign({}, account, payload);
          }
          return account;
        }),
        isUpdating: false,
        accountsMessage: 'Accounts has been updating!',
      })
    },
    UPDATING_ACCOUNT(state) {
      state.isUpdating = true;
    },
    DELETED_ACCOUNT(state, payload) {
      let indexToDelete = state.accounts.findIndex(account => account._id === payload._id);
      console.log(indexToDelete);
      let accounts = [...state.accounts];
      accounts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        accounts: [...accounts],
        isDeleting: false,
        idToDelete: null,
        accountsMessage: 'Account has been Deleted!',
      });
    },
    DELETING_ACCOUNT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getAccountsRequest({dispatch}) {
      dispatch("receivingAccounts");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/accounts';
      var header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      let get = { method: "get", url: url, headers: header };
      return axios(get).then(response => {
        dispatch("receiveAccounts", response.data);
      })
    },
    updateAccountRequest({dispatch}, payload) {
      dispatch("updatingAccount");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/account/' + id;
      let header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      axios({ method: "put", url: url, headers: header, data: payload })
      .then(function (res) {
        dispatch("updateAccount", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateAccountOptionsRequest({dispatch}, payload) {
      dispatch("updatingAccount");
      console.log('1',this.payload)
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/account/options/' + id;
      console.log(url)
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      axios({method: "put", url: url, headers: headers, data: payload})
      .then(function (response) {
        console.log(response);
        dispatch("updateAccount", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async insertAccountRequest({dispatch}, payload) {
      dispatch("receivingAccounts");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/account';
      let header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      let post = { method: "post", url: url, headers: header, data: payload };
      return axios(post)
      .then(function (response) {
        dispatch("receiveAccount", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteAccountRequest({dispatch}, payload) {
      dispatch("deletingAccount", payload);
      console.log(payload);
      axios.delete('https://api.accountxc.com:3100/delete/account/' + payload._id).then(() => {
        dispatch("deleteAccount", {_id: payload._id});
      })
    },
    clearAccounts({commit}) {
      commit("CLEAR_ACCOUNTS")
    },
    receiveAccounts({commit}, payload) {
      commit("RECEIVED_ACCOUNTS", payload)
    },
    receivingAccounts({commit}) {
      commit("RECEIVING_ACCOUNTS")
    },
    receiveAccount({commit}, payload) {
      commit("RECEIVED_ACCOUNT", payload)
    },
    receivingAccount({commit}) {
      commit("RECEIVING_ACCOUNT")
    },
    updateAccount({commit}, payload) {
      commit("UPDATED_ACCOUNT", payload)
    },
    updatingAccount({commit}) {
      commit("UPDATING_ACCOUNT")
    },
    deleteAccount({commit}, payload) {
      commit("DELETED_ACCOUNT", payload)
    },
    deletingAccount({commit}, payload) {
      commit("DELETING_ACCOUNT", payload)
    }
  },
};
